module.exports = __webpack_public_path__ + "img/register4.cf7095f3.svg";